import React from "react";
import { logout, getAccessToken } from "../components/utils/authTokenStore";

export default function Profile() {
  const isLoggedIn = !!getAccessToken();

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-3xl font-bold mb-4">Profile</h1>
      <p>This is the Profile page.</p>
      {isLoggedIn && (
        <button
          onClick={logout}
          className="mt-6 bg-red-500 hover:bg-red-400 text-white px-4 py-2 rounded"
        >
          Logout
        </button>
      )}
    </div>
  );
}